/* @flow */
import {Observable} from 'rxjs';
import {path, prop} from 'ramda';
import {fromJS, List, Map} from 'immutable';
import {combineEpics} from 'redux-observable';
import {ENCLAVE_MAPPING_FOR_CS_ENDPOINT, FETCH_SUMMARIES_ENDPOINT} from './constants';
import {
  FETCH_CS_ENCLAVE_SOURCE_FAILURE,
  FETCH_CS_ENCLAVE_SOURCE_MAP,
  FETCH_CS_ENCLAVE_SOURCE_SUCCESS,
  FETCH_SUMMARY,
  FETCH_SUMMARY_FAILURE,
  FETCH_SUMMARY_SUCCESS,
  FETCH_SUMMARIES_FOR_REPORTS,
  FETCH_SUMMARIES_FOR_REPORTS_FAILURE,
  FETCH_SUMMARIES_FOR_REPORTS_SUCCESS,
} from './action-types';
import * as Utils from './utils';

/* Fetches summary table */
const fetchSummaryEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_SUMMARY)
    .mergeMap(({ payload }) => {
     return ajax.get(Utils.resolveSummaryEndpoint(payload))
        .map(({response}) => ({
          type: FETCH_SUMMARY_SUCCESS,
          payload: Utils.normalizeSummary(response),
        }))
        .catch(err => Observable.of({ type: FETCH_SUMMARY_FAILURE, payload: err }));
    });

const fetchClosedSourceEnclaveMap = (action$, store, { ajax }) =>
  action$.ofType(FETCH_CS_ENCLAVE_SOURCE_MAP)
    .mergeMap(({payload}) => {
      return ajax.get(ENCLAVE_MAPPING_FOR_CS_ENDPOINT)
        .map(({response}) => ({
          type: FETCH_CS_ENCLAVE_SOURCE_SUCCESS,
          payload: fromJS(response).toOrderedMap(),
        }))
        .catch(err => Observable.of({ type: FETCH_CS_ENCLAVE_SOURCE_FAILURE, payload: err }));    });

// Given a list of reportIds, returns summaries for each of the reports
const fetchSummariesForReports = (action$, store, { ajax }) =>
  action$.ofType(FETCH_SUMMARIES_FOR_REPORTS)
    .mergeMap(({ payload }) => {
      return ajax
        .postJSON(FETCH_SUMMARIES_ENDPOINT, payload)
        .map(({response}) => ({
          type: FETCH_SUMMARIES_FOR_REPORTS_SUCCESS,
          payload: fromJS(response),
        }))
        .catch(err => Observable.of({ type: FETCH_SUMMARIES_FOR_REPORTS_FAILURE, payload: err }));
    });


export default combineEpics(
  fetchSummaryEpic,
  fetchClosedSourceEnclaveMap,
  fetchSummariesForReports
);



// WEBPACK FOOTER //
// ./src/app/modules/summaries/epics.js